/**
 * Reusable Framer Motion animation variants for the Monarch dashboard.
 */
import type { Variants, Transition } from 'framer-motion';

/* ── Stagger Container ── */

export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.06,
    },
  },
};

/* ── Fade-in-up (for KPI cards, individual items) ── */

export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] },
  },
};

/* ── Slide-in from right (for drill panels) ── */

export const slideInRight: Variants = {
  hidden: { x: '100%' },
  visible: {
    x: 0,
    transition: { type: 'spring', stiffness: 300, damping: 30 },
  },
  exit: {
    x: '100%',
    transition: { duration: 0.2, ease: 'easeIn' },
  },
};

/* ── Backdrop fade ── */

export const fadeBackdrop: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.2 } },
  exit: { opacity: 0, transition: { duration: 0.15 } },
};

/* ── Page content fade-in ── */

export const pageTransition: Transition = {
  duration: 0.4,
  ease: [0.22, 1, 0.36, 1],
};

export const pageInitial = { opacity: 0, y: 12 };
export const pageAnimate = { opacity: 1, y: 0 };
